<template>
	<v-textarea
		dense
		:hide-details="hideDetails"
		v-model="inputValue"
		:error="errorBorder"
		:error-messages="$props.error"
		:label="$props.label"
		:placeholder="$props.placeholder"
		:readonly="readonly"
		:disabled="disabled"
		:type="$props.type"
		:rows="$props.rows"
		:no-resize="$props.noResize"
		outlined
	></v-textarea>
</template>

<script>
export default {
	name: 'TextArea',
	props: {
		value: String,
		readonly: Boolean,
		disabled: Boolean,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
		placeholder: String,
		label: String,
		type: String,
		rows: {
			type: Number,
			default: 5,
		},
		noResize: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			inputValue: this.$props.value,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		inputValue() {
			this.$emit('input', this.inputValue);
		},
		value() {
			this.inputValue = this.$props.value;
		},
	},
};
</script>

<style scoped></style>
